import React, { useState } from 'react';
import { Input, Button } from 'elements';
import strings from '../../../../utils/translationStrings';

import './FreeTrialSection.scss';

export const FreeTrialSection = () => {

  const [ email, setEmail ] = useState('');

  const submit = (event) => {
    event.preventDefault();
    window.location.replace(`${process.env.REACT_APP_DASHBOARD_URL}/auth/sign-up?email=${email}`);
  };

  return (
    <section id="free-trial" className="free-trial">
      <div className="free-trial__container">
        <h1>{strings.landing.mainSlogan}</h1>
        <form className="free-trial__form" onSubmit={event => submit(event)}>
          <Input
            type="email"
            name="email"
            placeholder={strings.landing.emailPlaceholder}
            additionalClass="free-trial__form--email"
            onInput={(event) => setEmail(event.target.value)}
          />
          <Button
            type="submit"
            title={strings.shared.trial}
            additionalClass="free-trial__form--button"
          />
        </form>
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Landing/Partial/FreeTrialSection/FreeTrialSection.js